var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":"","pa-0":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('circle-spinner')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }